import { Preview } from "@creatomate/preview";
import { ElementSource } from "chq";
import { isSubtitleText } from "../../sidebar/tabs/subtitle/utils";

const MIN_VIDEO_DURATION = 240; // 240s / 60 = 4min
const MIN_PART_DURATION = 60;
const MAX_SEGMENTS = 5;

const isMultipartRequired = (totalDuration: number): boolean => totalDuration > MIN_VIDEO_DURATION;

const getSegmentedMultipart = (totalDuration: number): number[] => {
  const numberOfSegments = Math.min(Math.floor(totalDuration / MIN_PART_DURATION), MAX_SEGMENTS);
  const segmentDuration = totalDuration / numberOfSegments;
  const distribution: number[] = [];
  let currentSegment = segmentDuration;

  for (let i = 0; i < numberOfSegments; i += 1) {
    distribution.push(Math.ceil(currentSegment));
    currentSegment = Math.min(currentSegment + segmentDuration, totalDuration);
  }

  distribution.pop();
  return distribution;
};

const getCreatomateMediaData = (preview: Preview, burnSubtitles: boolean): ElementSource => {
  const mediaData = preview.getSource();
  const filteredElements = burnSubtitles
    ? mediaData.elements
    : mediaData.elements.filter((element: ElementSource) => !isSubtitleText(element.name));
  const totalDuration = preview.state?.duration || 0;
  if (isMultipartRequired(totalDuration)) {
    mediaData.duration = `${totalDuration} s`;
    mediaData.multipart = getSegmentedMultipart(totalDuration);
  }
  return { ...mediaData, elements: filteredElements };
};

export default getCreatomateMediaData;
